import React, { useState, useEffect } from 'react'
import {Link} from 'react-router-dom'

const Home = () => {
	const [username, setUsername] = useState(null)

	// const URL = import.meta.env.VITE_BASE_URL;

	useEffect(() => {
		fetch(`${process.env.REACT_APP_API_URL}/profile`, {
			credentials: 'include',
		}).then(response => {
			response.json().then(userInfo => {
				setUsername(userInfo.username)
			})
		})
	}, [])

	function logout() {
		fetch(`${process.env.REACT_APP_API_URL}/logout`, {
			credentials: 'include',
			methos: 'POST',
		})
		setUsername(null)
	}

	return (
		<>
			<header>
				<Link to="/">Admin</Link>
				<nav>
					{username && (
						<>
							<Link to="/create">Create new blog</Link>
							<button
								type="button"
								onClick={logout}
								className="cursor-pointer bg-transparent border-0 p-0 text-inherit"
								>
								Logout
							</button>
						</>
					)}
					{!username && (
						<>
							<Link to="/admin/login">Login</Link>
							<Link to="/admin/register">Register</Link>
						</>
					)}
				</nav>
			</header>
		</>
	)
}

export default Home